import "./StyledSelect.scss";

import { useCallback } from "react";
import type { StylesConfig } from "react-select";
import Select, { components } from "react-select";

import DropdownIndicator from "./DropdownIndicator";

interface IOption {
  value: string;
  label: string | JSX.Element;
  default?: boolean;
  selected?: boolean;
}

const style: StylesConfig = {
  control: (provided: any) => ({
    ...provided,
    height: 37,
    minHeight: 37,
    boxShadow: "none",
    border: "none",
    marginBottom: 2,
    padding: "0px 10px",
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided,
    display: "none",
  }),
};

export interface StyledSelectProps {
  options: IOption[];
  onChange: (data: any) => void;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  isSearchable?: boolean;
  placeholder?: string;
  isBootstrap?: boolean;
  value?: IOption;
  components?: any;
}

const StyledSelect: React.FC<StyledSelectProps> = ({
  options,
  onChange,
  isClearable = false,
  isDisabled = false,
  isLoading = false,
  isSearchable = false,
  isBootstrap = false,
  placeholder = "",
  value,
}) => {
  // eslint-disable-next-line
  const renderPlaceholder = useCallback(
    (props: any) => {
      return (
        <components.Placeholder {...props}>
          <span>{placeholder}</span>
        </components.Placeholder>
      );
    },
    [placeholder],
  );

  const renderIndicator = useCallback((props: any) => {
    return <DropdownIndicator {...props} />;
  }, []);

  return (
    <div className="custom-select-container">
      {isBootstrap ? (
        <select
          className="form-select form-control custom-form-control shadow-none border-0"
          aria-label={placeholder}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <Select
          styles={style}
          options={options}
          value={value}
          onChange={onChange}
          className="custom-select__select"
          classNamePrefix="react-select"
          isClearable={isClearable}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isSearchable={isSearchable}
          placeholder={placeholder}
          components={{
            Placeholder: renderPlaceholder,
            DropdownIndicator: renderIndicator,
          }}
        />
      )}
    </div>
  );
};

export { type IOption, StyledSelect };
